import { get } from "lodash-es";
import axios from "axios";

export default {
  state: () => ({
    tickets: [],
  }),
  mutations: {
    setData(state, payload) {
      state.tickets = payload;
    },
  },
  actions: {
    async getData(context, payload) {
      const resp = await axios.post("/execute", {
        method: "CLI.GetTicketConIteraciones",
        parameters: [
          {
            name: "id_ticket",
            value: payload.idTicket,
          },
        ],
      });
      if (get(resp.data, "ok", false)) {
        context.ticket = get(resp.data, "result[0][0]", null);

        context.iteraciones = get(resp.data, "result[1]", []);
      }
      return resp.data;
    },
  },
  gettters: {
    getTickets(state) {
      return state.tickets;
    },
  },
};
